angular.module('zc.core')

.directive 'zcDownloadCampaignDataButton', ($q, clientReportCsvCreator, CampaignStats) ->
  restrict: 'E'
  scope:
    filters: '='
    project: '='
    campaigns: '='
    isAb: '='
  template: """
            <button
              class="btn btn-sm pull-right btn-default"
              ng-csv="getCSV()"
              add-bom="true"
              charset="utf-16"
              field-separator="\\t"
              filename="report_{{project.apikey}}_{{date}}.csv">
              <i class="fa fa-cloud-download"></i> {{ 'sharedModules.core.directives.download_campaign_data_button' | translate }}
            </button>
            """
  link: (scope, element, attrs) ->
    scope.date = moment().format('YYYYMMDD')

    scope.prepareCampaigns = (campaigns) ->
      $q (resolve) ->
        result = []
        campaigns = _.sortBy campaigns, (campaign) -> campaign.id
        for campaign in campaigns
          start_at = new Date(scope.filters.start_at)
          end_at = moment(scope.filters.end_at).endOf('day').toDate()
          if new Date(campaign.start_at) > start_at
            start_at = new Date(campaign.start_at)
          if new Date(campaign.end_at) < end_at
            end_at = new Date(campaign.end_at)

          c = _.assignIn {}, campaign
          c.start_at = start_at
          c.end_at = end_at
          c.stats?.invoice_amount = CampaignStats.calculateInvoiceAmount(scope.project, c, c.stats)
          result.push c
        resolve result

    scope.getCSV = ->
      $q (resolve) ->
        scope.prepareCampaigns(scope.campaigns)
        .then (campaignsWithStats) ->
          clientReportCsvCreator.createCsv(scope.project, campaignsWithStats, scope.isAb)
        .then (res) -> resolve res



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/download_campaign_data_button.directive.coffee